module.exports = "https://coursera_assets.s3.amazonaws.com/images/dbbd1f929548aa2b3b38c0e6b2887a0f.png";